import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import DebriefDialogTitle from 'ff/debrief/components/modals/DebriefDialogTitle';
import { WhatsNewItem } from 'ff/debrief/models';
import { WhatsNewFooter } from 'ff/debrief/components/whatsNew/WhatsNewFooter';
import { WhatsNewContent } from 'ff/debrief/components/whatsNew/WhatsNewContent';
import { WhatsNewVideo } from 'ff/debrief/components/whatsNew/WhatsNewVideo';

interface Props {
    open: boolean;
    items: WhatsNewItem[];
    currentIndex: number;
    onClose: () => void;
    onNext: () => void;
    onExited: () => void;
}

const IMAGE_WIDTH = 480;
const IMAGE_HEIGHT = 270;

const WhatsNewModal: React.FC<Props> = ({
    open,
    items,
    currentIndex,
    onClose,
    onNext,
    onExited,
}) => {
    if (!items.length) return null;

    const item = items[currentIndex];
    const imageUrl = `${item.media}`;
    const isLastItem = currentIndex === items.length - 1;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            TransitionProps={{ onExited }}
            PaperProps={{
                style: {
                    width: IMAGE_WIDTH + 48,
                    maxWidth: IMAGE_WIDTH + 48,
                },
            }}
        >
            <DebriefDialogTitle onClose={onClose}>
                What&#39;s New
            </DebriefDialogTitle>

            <DialogContent>
                <WhatsNewVideo
                    key={imageUrl}
                    width={IMAGE_WIDTH}
                    height={IMAGE_HEIGHT}
                    src={imageUrl}
                />
                <WhatsNewContent item={item} />
            </DialogContent>

            <WhatsNewFooter currentIndex={currentIndex} total={items.length} />

            <DialogActions sx={{ justifyContent: 'flex-end', pb: 2, pr: 3 }}>
                <Button onClick={onClose} size="small">
                    Skip Tour
                </Button>
                <Button
                    onClick={isLastItem ? onClose : onNext}
                    variant="contained"
                    size="small"
                    color="primary"
                >
                    {isLastItem ? 'Finish' : 'Next'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WhatsNewModal;
